import { getQuotaLogs } from '@/api/portal/member'
import { setCachedQuotaBalance } from '@/utils/auth'

/**
 * 工作台及各功能页 Layout 共用：顶栏 / 充值弹窗打开兑换码。
 */
export default {
  data() {
    return {
      showRedeemCode: false
    }
  },
  methods: {
    handleRedeemCode() {
      if (!this.loggedIn) {
        this.goLogin()
        return
      }
      this.showRedeemCode = true
    },
    onRedeemSuccess(data) {
      const available = data.available != null ? data.available : data.balance
      if (available != null) {
        this.quotaBalance = available
        setCachedQuotaBalance(this.quotaBalance)
      } else if (typeof this.refreshQuotaBalance === 'function') {
        this.refreshQuotaBalance()
      }
      if (typeof this.loadPointsLedger === 'function') {
        this.loadPointsLedger()
      } else if (Array.isArray(this.pointsLedger)) {
        this.reloadPointsLedgerAfterRedeem()
      }
      if (typeof this.refreshPptEntitlement === 'function') {
        this.refreshPptEntitlement()
      }
    },
    reloadPointsLedgerAfterRedeem() {
      getQuotaLogs({ page: 1, pageSize: 20 })
        .then(res => {
          const rows = res.data || []
          this.pointsLedger = rows.map(item => ({
            time: item.createTime,
            type: item.changeTypeLabel || item.changeType,
            amount: item.changeAmount,
            balance: item.balanceAfter
          }))
        })
        .catch(() => {})
    }
  }
}
